import { STORE } from "../../../data/storeData";

export default function Footer() {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative bg-secondary-900 text-background-50 pt-14 pb-8">
      <div className="rope-border absolute top-0 left-0 right-0 opacity-80" />
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-11 h-11 rounded-full bg-primary-600 flex items-center justify-center">
                <i className="ri-anchor-line text-xl"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-[10px] font-bold tracking-widest text-accent-300">KOBE</span>
                <span className="font-heading font-black text-base">ミナトマチカレー</span>
              </div>
            </div>
            <p className="text-xs text-background-200 leading-relaxed">
              神戸の海辺に、
              <br />
              新しいカレーの旗が立つ。
            </p>
            <p className="mt-3 text-xs text-background-300 leading-relaxed">
              {STORE.postalCode} {STORE.address}
              <br />
              {STORE.facilityName} {STORE.floorLabel}
              <br />
              {STORE.phone && (
                <a href={`tel:${STORE.phone}`} className="cursor-pointer hover:text-accent-300">
                  {STORE.phoneDisplay}
                </a>
              )}
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href={STORE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-accent-500 hover:text-secondary-900 flex items-center justify-center transition"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href={STORE.tiktokUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="TikTok"
                className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-accent-500 hover:text-secondary-900 flex items-center justify-center transition"
              >
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <p className="font-heading font-black text-sm mb-3 text-accent-300">MENU</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#menu" className="hover:text-accent-300 whitespace-nowrap cursor-pointer">メニュー</a></li>
              <li><a href="#concept" className="hover:text-accent-300 whitespace-nowrap cursor-pointer">コンセプト</a></li>
              <li><a href="#feature" className="hover:text-accent-300 whitespace-nowrap cursor-pointer">こだわり</a></li>
            </ul>
          </div>

          <div>
            <p className="font-heading font-black text-sm mb-3 text-accent-300">INFO</p>
            <ul className="space-y-2 text-sm">
              <li><a href="#store" className="hover:text-accent-300 whitespace-nowrap cursor-pointer">店舗情報</a></li>
              <li><a href="#gift" className="hover:text-accent-300 whitespace-nowrap cursor-pointer">プレゼント</a></li>
              <li><a href="#news" className="hover:text-accent-300 whitespace-nowrap cursor-pointer">お知らせ</a></li>
            </ul>
          </div>

          <div>
            <p className="font-heading font-black text-sm mb-3 text-background-300">運営会社</p>
            <ul className="space-y-2 text-sm text-background-300">
              <li>
                <a href={STORE.operatorSiteUrl} target="_blank" rel="noopener noreferrer" className="hover:text-accent-300 whitespace-nowrap cursor-pointer">
                  {STORE.operatorName}
                </a>
              </li>
              <li className="text-[11px] text-background-500 leading-tight">
                {STORE.operatorDesc}
              </li>
              <li>
                <a href={STORE.recruitUrl} target="_blank" rel="noopener noreferrer" className="hover:text-accent-300 whitespace-nowrap cursor-pointer text-xs">
                  採用情報（スタッフ募集）
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200">
            © 2026 KOBEミナトマチカレー
          </p>
          <button
            onClick={scrollTop}
            className="w-14 h-14 rounded-full bg-background-50 text-secondary-900 flex flex-col items-center justify-center font-heading font-black text-[10px] leading-none cursor-pointer hover:bg-accent-300 transition"
          >
            <i className="ri-arrow-up-line text-lg"></i>
            <span className="mt-0.5">TOP</span>
          </button>
        </div>
      </div>
    </footer>
  );
}